/**
 * Event defaults shared by the portal.
 * The event a visitor lands on when nothing else is known (no `last_event`,
 * no event in the URL). Override per environment with REACT_APP_DEFAULT_EVENT.
 */
export const DEFAULT_EVENT_NAME_ID = process.env.REACT_APP_DEFAULT_EVENT || 'F4C2027';

export const getLastEventNameId = () => {
    try {
        return localStorage.getItem('last_event') || DEFAULT_EVENT_NAME_ID;
    } catch (e) {
        return DEFAULT_EVENT_NAME_ID;
    }
};

export const eventHomePath = (eventNameId = getLastEventNameId()) => `/event/${eventNameId}/home`;

/** Signed-in landing page: the list of events with the user's status for each. */
export const EVENTS_LIST_PATH = '/events';

export const eventRegistrationPath = (eventNameId) => `/event/${eventNameId}/registration`;

/** An event is archived once its last day has passed. */
export const isEventPast = (event) => {
    if (!event) return false;
    if (typeof event.is_past === 'boolean') return event.is_past;
    const end = event.EndDate || event.StartDate;
    if (!end) return false;
    const endTime = new Date(end).getTime();
    return !Number.isNaN(endTime) && endTime < Date.now();
};

/**
 * Registration status keys returned by GET /public/events, grouped for display.
 * `confirmed` means the contact is an attendee; the "pending" group covers every
 * registration that has been started but not confirmed yet.
 */
export const REGISTRATION_STATUS = {
    confirmed: { tone: 'green', label: 'Registered' },
    in_review: { tone: 'amber', label: 'In review' },
    registering: { tone: 'amber', label: 'Registration started' },
    pending_payment: { tone: 'amber', label: 'Pending payment' },
    needs_invoice: { tone: 'amber', label: 'Pending payment' },
    declined: { tone: 'red', label: 'Declined' },
    cancelled: { tone: 'gray', label: 'Cancelled' },
    inactive: { tone: 'gray', label: 'Inactive' },
    none: { tone: 'gray', label: 'Not registered' },
};

export const describeRegistration = (registration) => {
    const key = registration?.status || 'none';
    return REGISTRATION_STATUS[key] || REGISTRATION_STATUS.none;
};

export const isRegistered = (registration) => registration?.status === 'confirmed';

/** Can the signed-in contact (re)start registration for this event? */
export const canRegister = (event) => {
    if (!event || isEventPast(event)) return false;
    const status = event.registration?.status || 'none';
    return status === 'none' || status === 'registering' || status === 'cancelled' || status === 'inactive';
};
